<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">关键字：</div>
                        <el-input v-model="artName" placeholder="请输入关键字" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">手机号：</div>
                        <el-input v-model="userTel" placeholder="请输入手机号" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">日期：</div>
                        <el-date-picker v-model="sendTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" clearable>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 新增文章按钮 -->
        <div class="whiteBg main-middle">
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" ref="fbTable"
                v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="pageSize"
                @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="50%" :close-on-click-modal="false">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item label="反馈内容：">
                    <el-input type="textarea" :value="currentText" style="width: 320px;" disabled
                        placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="回复内容：" prop="replyContent">
                    <wang-editor :mainBody="ruleForm.replyContent"
                        @onChange="(str) => { ruleForm.replyContent = str }"></wang-editor>
                </el-form-item>
                <div class="box box-align-center box-pack-end mt12 mt-btns" style="margin-right: 30px;">
                    <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
                    <el-button type="danger" plain @click="() => addVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import host from '@/api/index';
import wangEditor from '@/components/common/wangEditor/index'
import ActicleCommon from '@/components/common/articleCommon/index'
import jumpTypeVue from '@/components/common/jumpType/index'
import { suggestList, suggestDetail, deleteSuggest, suggestReply } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, arrToStr } from '@/utils/utils';
import { pushUserType, operatingSystem, jumpType, messageType, contentType } from '@/utils/commonData';
var that = null;
export default {
    components: {
        DyTable,
        ActicleCommon,
        jumpTypeVue,
        wangEditor
    },
    data() {
        const { doEdit } = this;
        const { doDelete } = this;
        return {
            showAddArticleVisible: false,
            artName: '',
            sendTime: '',
            pushUserType,
            operatingSystem,
            jumpType,
            contentType,
            tableLoading: true,
            topicId: '',
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'bgUserName',
                    title: '名字'
                },
                {
                    key: 'userTel',
                    title: '手机号'
                },
                {
                    key: 'type',
                    title: '反馈类型'
                },
                {
                    key: 'userType',
                    title: '身份类型'
                },
                {
                    key: 'content',
                    title: '内容'
                },
                {
                    key: 'createtime',
                    title: '日期'
                },
                {
                    key: 'replytime',
                    title: '回复时间'
                },
                {
                    key: '',
                    title: '操作',
                    width: 100,
                    render: ({ row }) => {
                        if (row.status == 2) {
                            return (
                                <div>
                                    <el-link type="primary" onClick={() => doEdit(row.id)}>查看</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDelete(row.id)}>删除</el-link>
                                </div>
                            );
                        } else {
                            return (
                                <div>
                                    <el-link type="primary" onClick={() => doEdit(row.id)}>查看</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => doDelete(row.id)}>删除</el-link>
                                </div>
                            );
                        }
                    }
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            ruleForm: {
                id: '',
                replyContent: '',
            },
            rules: {
                replyContent: [
                    { required: true, message: '请输入回复内容', trigger: 'blur' },
                ],
            },
            addVisible: false,
            options: [],
            value: '',
            status: '',
            dialogTitle: '详情',
            messageType,
            userTel: '',
            currentText: '',
            currentId: '',
        }
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token') // 直接从本地获取token就行
            };
        }
    },
    mounted() {
        that = this;
        that.getList();
    },
    methods: {
        //重置列表
        resetList() {
            that.currentPage = 1;
            that.artName = '';
            that.userTel = '';
            that.sendTime = '';
            that.getList();
        },
        //编辑
        doEdit(id) {
            let info = {
                id
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            suggestDetail(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log('详情', ress);
                    that.currentText = ress.content;
                    that.ruleForm.id = id;
                    that.addVisible = true;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //删除
        doDelete(id) {
            that.$confirm('确认要删除这条反馈吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    id
                };
                console.log(info);
                var data = encrypt(JSON.stringify(info));
                deleteSuggest(data).then((res) => {
                    that.getList();
                });
            })
        },
        // 提交表单
        submitForm(formName) {
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    var info = that.ruleForm;
                    console.log(info, '我是表单');
                    var data = encrypt(JSON.stringify(info));
                    suggestReply(data).then((res) => {
                        if (res.result == 1) {
                            console.log(res);
                            that.addVisible = false;
                            that.$message({
                                showClose: true,
                                message: '回复成功',
                                type: 'success'
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        getList() {
            that.tableLoading = true;
            console.log('time', that.sendTime);
            let info = {
                page: that.currentPage,
                pageSize: that.pageSize,
                content: that.artName,
                userTel: that.userTel,
                from: that.sendTime ? that.sendTime[0] : '',
                to: that.sendTime ? that.sendTime[1] : '',
                needPage: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            suggestList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('意见反馈列表', ress);
                    that.total = ress.total;
                    that.currentPage = ress.pageNum;
                    that.tableData = ress.list.map(item => {
                        return {
                            ...item,
                            createtime: item.createtime ? formatDate(new Date(item.createtime), 'yyyy-MM-dd hh:mm:ss') : '',
                            operatetime: item.operatetime ? formatDate(new Date(item.operatetime), 'yyyy-MM-dd hh:mm:ss') : '',
                            replytime: item.replytime ? formatDate(new Date(item.replytime), 'yyyy-MM-dd hh:mm:ss') : '',
                            userType: pushUserType[item.userType - 1].label,
                        }
                    });
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        }
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
/deep/.el-textarea.is-disabled .el-textarea__inner {
    background-color: transparent;
}

/deep/.el-tabs__item {
    min-width: 100px;
    text-align: center;
    padding: 0;
}

/deep/.el-dropdown {
    margin-right: 10px;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>